import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Combines conditional class names (clsx) and resolves Tailwind
 * class conflicts (tailwind-merge) into a single stable string.
 * Both dependencies are already present in package.json.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
